import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectSource } from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { eventLogger } from 'services/eventLogger.service'

import { SubscriptionContainer as Container } from 'common-styles'

import { StyledWithdrawalCard as S } from './WithdrawalCard.styles'

interface IWithdrawalCardProps {
  subscriptionId: string
  contract: string
  onRequestWithdrawal: (subscriptionId: string, contract: string) => void
}

export const WithdrawalCard: React.FC<IWithdrawalCardProps> = ({
  subscriptionId,
  contract,
  onRequestWithdrawal,
}) => {
  const { t } = useTranslation()
  const source = useSelector(selectSource)
  const userId = useSelector(selectUUID)

  const handleClick = () => {
    eventLogger.logCancelPurchaseButtonTap(source, userId)
    onRequestWithdrawal(subscriptionId, contract)
  }

  return (
    <Container.Root isBottomSeparatorHidden>
      <S.Link type="button" onClick={handleClick}>
        {t('subscription.withdrawalCard.title')}
      </S.Link>
      <S.Description>
        {t('subscription.withdrawalCard.description')}
      </S.Description>
    </Container.Root>
  )
}
